module.exports = __webpack_public_path__ + "static/media/address.528195d6.svg";